import React from "react";
import styles from "./index.module.scss";
import { classNames, isJudge } from "../../tool";
import IScroll from "./js/iscroll-probe.js";

// 外部记录滚动的数值
let scrollY = 0;
let timer = null;

/**
 *上拉加载下拉刷新
 *
 * @export
 * @class Iscroll
 */
class Iscroll extends React.PureComponent {
  timerRefresh; // 刷新iscroll的延时timer
  iscrollTimer; // 检测高度变化的timer
  myScroll; // 保存当前iscroll实例
  docStatus;

  constructor(props) {
    super(props);
    this.state = {
      yesDown: false, // 是否已到了下拉刷新的高度
      yesUp: false, // 是否已到了上拉加载的高度
      data: null, // 数据缓存,
      loadingDownShow: false, // 是否处于刷新中状态
      loadingUpShow: false, // 是否属于加载中状态
      iscrollOptions: {
        // iscroll 所需参数
        probeType: 3,
        preventDefault: true,
        click: true,
      },
      options: {
        backgroundColor: "transparent", // 背景颜色
        fontColor: "#a5a9b3", // 文字颜色
        beyondHeight: 30, // 超过此长度后触发下拉或上拉,单位px
        pulldownInfo: "刷新数据",
        pulldownReadyInfo: "松开刷新数据",
        pulldowningInfo: "",
        pullupInfo: "加载更多",
        pullupReadyInfo: "松开加载更多",
        pullupingInfo: "数据加载中...",
        noUpStr: "- 已加载全部内容 -",
      },
      boxHeight: 0,
    };

    this.timerRefresh = null;
    this.iscrollTimer = null;
    this.myScroll = null;
    this.docStatus = null;
  }

  // 组件初始化完毕时触发
  async componentDidMount() {
    try {
      this.myScroll = new IScroll(
        `#${this.props.id}_warpper`,
        Object.assign({}, this.state.iscrollOptions, this.props.iscrollOptions)
      );
      this.myScroll.on("scroll", () => {
        const myScroll = this.myScroll;
        if (
          myScroll.y >= this.state.options.beyondHeight &&
          !this.state.yesDown
        ) {
          this.setState({
            yesDown: true,
          });
        } else if (
          myScroll.y > 0 &&
          myScroll.y < this.state.options.beyondHeight &&
          this.state.yesDown
        ) {
          this.setState({
            yesDown: false,
          });
        } else if (
          myScroll.y < myScroll.maxScrollY &&
          myScroll.y > myScroll.maxScrollY - this.state.options.beyondHeight &&
          this.state.yesUp
        ) {
          this.setState({
            yesUp: false,
          });
        } else if (
          myScroll.y < myScroll.maxScrollY - this.state.options.beyondHeight &&
          !this.state.yesUp
        ) {
          this.setState({
            yesUp: true,
          });
        }
        if (this.props.loadMore) {
          if (myScroll.y <= myScroll.maxScrollY + myScroll.wrapperHeight) {
            clearTimeout(timer);
            timer = setTimeout(() => {
              this.props.loadMore();
            }, 100);
          }
        }
        // 添加滚动回调
        if (this.props.getScrollPosition) {
          this.props.getScrollPosition(myScroll.y);
        }
      });

      this.myScroll.on("scrollStart", () => {
        window.top.addEventListener("mouseup", this.onMouseUpListener, false);
        window.top.addEventListener("touchend", this.onMouseUpListener, false);
      });
      this.onRefresh();
    } catch (error) {
      console.log(error);
      //
    }
    this.setState({
      data: this.props.children,
      options: Object.assign({}, this.state.options, this.props.options),
    });

    if (this.props.detectionHeight) {
      this.onDetectionHeight();
    }

    // 处理safari兼容性问题
    if (this.docStatus) {
      this.docStatus.addEventListener(
        "touchmove",
        (ev) => {
          ev.preventDefault();
        },
        { passive: false, capture: false }
      );
    }
    if (scrollY !== 0 && this.props.history.action === "POP") {
      this.myScroll.scrollTo(0, scrollY);
    }
  }

  componentDidUpdate(prevP, prevS) {
    if (
      prevS.data !== this.state.data ||
      prevP.noDown !== this.props.noDown ||
      prevP.noUp !== this.props.noUp
    ) {
      this.onRefresh();
    }
  }

  /** 组件即将销毁时触发，销毁当前iscroll实例 **/
  componentWillUnmount() {
    window.clearTimeout(this.iscrollTimer);
    if (this.myScroll) {
      this.myScroll.destroy();
    }
    scrollY = this.myScroll.y;
  }

  onMouseUpListener = () => {
    window.top.removeEventListener("mouseup", this.onMouseUpListener, false);
    window.top.removeEventListener("touchend", this.onMouseUpListener, false);
    // 如果滑动距离超过了设定界限并且当前没在下拉中，就触发下拉
    if (
      this.myScroll.y >= this.state.options.beyondHeight &&
      !this.state.loadingDownShow
    ) {
      if (
        !this.props.noDown &&
        (this.props.onDown || this.props.onPullDownRefresh)
      ) {
        this.setState({
          loadingDownShow: true,
          loadingUpShow: false,
        });
        if (this.props.onDown) {
          this.props.onDown();
        } else if (this.props.onPullDownRefresh) {
          this.props.onPullDownRefresh();
        }
      }
    } else if (
      this.myScroll.y <
        this.myScroll.maxScrollY - this.state.options.beyondHeight &&
      !this.state.loadingUpShow
    ) {
      if (this.props.noUp && this.props.noUpCallback) {
        this.props.noUpCallback();
        return;
      }
      if (
        !this.props.noUp &&
        (this.props.onUp || this.props.onPullUpLoadMore)
      ) {
        this.setState({
          loadingDownShow: false,
          loadingUpShow: true,
        });
        if (this.props.onUp) {
          this.props.onUp();
        } else if (this.props.onPullUpLoadMore) {
          this.props.onPullUpLoadMore();
        }
      }
    }
  };

  /** children内容改变时触发,表示已完成了刷新或加载 **/

  static getDerivedStateFromProps(nextP, prevState) {
    if (nextP.children !== prevState.data) {
      return {
        data: nextP.children,
        loadingDownShow: false,
        loadingUpShow: false,
      };
    }
    return null;
  }

  /** 循环检测容器高度 **/
  onDetectionHeight() {
    clearTimeout(this.iscrollTimer);
    this.iscrollTimer = setTimeout(() => {
      this.iscrollTimeout();
    }, 500);
  }

  iscrollTimeout() {
    const dom = this.docStatus;
    if (dom && dom.offsetHeight !== this.state.boxHeight) {
      this.setState({
        boxHeight: dom.offsetHeight,
      });
      this.myScroll.refresh();
    }
    this.iscrollHeightChange();
  }

  iscrollHeightChange() {
    clearTimeout(this.iscrollTimer);
    this.iscrollTimer = setTimeout(() => {
      this.iscrollTimeout();
    }, 700);
  }

  /** 刷新ISCROLL **/
  onRefresh() {
    const myScroll = this.myScroll;
    window.clearTimeout(this.timerRefresh);
    this.timerRefresh = window.setTimeout(() => {
      if (myScroll.refresh) {
        myScroll.refresh();
      }
    }, 200);
  }

  scrollContent = () => {
    return (
      <React.Fragment>
        <div
          id={`${this.props.id}_warpper`}
          className={classNames(styles.slScroller, this.props.cls)}
        >
          <div id="scrollContent">
            <div className={styles.scrollerPullDown}>
              {this.props.hideRefreshIcon ? (
                ""
              ) : (
                <span
                  className={classNames(
                    styles.icon,
                    isJudge(this.state.yesDown)(styles.reverseIcon, null)
                  )}
                  style={{
                    display: this.props.noDown ? "none" : "inline-block",
                  }}
                >
                  <img
                    width={"0.4rem"}
                    height={"0.4rem"}
                    className={styles.refresh}
                    src={
                      !this.props.specialLoading
                        ? require("./images/freshLoadingInHome.gif")
                        : require("./images/scroll-loading.gif")
                    }
                    alt=""
                  />
                </span>
              )}
              {!this.props.specialLoading ? (
                ""
              ) : (
                <span
                  className={styles.msg}
                  style={{
                    color: this.state.options.fontColor,
                    display: isJudge(this.props.noDown)("none", "inline-block"),
                  }}
                >
                  {this.state.yesDown
                    ? this.state.options.pulldownReadyInfo
                    : this.state.options.pulldownInfo}
                </span>
              )}
              <span
                className={styles.msg}
                style={{
                  color: this.state.options.fontColor,
                  display: isJudge(this.props.noDown)("inline-block", "none"),
                }}
              >
                {this.props.noDownStr}
              </span>
            </div>
            <div className={styles.scrollerContent}>
              {this.props.children}
              {this.props.tips ? (
                <div
                  className={styles.tips}
                  style={{ color: this.props.tipsColor }}
                >
                  {this.props.tips}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={styles.scrollerPullUp}>
              <span
                className={classNames(
                  styles.icon,
                  isJudge(this.state.yesUp)(styles.reverseIcon, null)
                )}
                style={{
                  display: isJudge(this.props.noUp)("none", "inline-block"),
                }}
              >
                <img
                  width={"0.4rem"}
                  height={"0.4rem"}
                  className={styles.refresh}
                  src={require("./images/scroll-loading.gif")}
                  alt=""
                />
              </span>
              <span
                className={styles.msg}
                style={{
                  color: this.state.options.fontColor,
                  display: isJudge(this.props.noUp)("none", "inline-block"),
                }}
              >
                {this.state.yesUp
                  ? this.state.options.pullupReadyInfo
                  : this.state.options.pullupInfo}
              </span>

              {this.props.hideNoUpStr ? (
                ""
              ) : (
                <span
                  className={styles.msg}
                  style={{
                    color: this.state.options.fontColor,
                    display: isJudge(this.props.noUp)("inline-block", "none"),
                  }}
                >
                  {this.state.options.noUpStr}
                </span>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div
        id={this.props.id}
        ref={(dom) => (this.docStatus = dom)}
        className={classNames(this.props.className, styles.iscrollBox)}
      >
        {this.scrollContent()}
      </div>
    );
  }
}

export default Iscroll;
